/* eslint-disable no-unused-vars */
import React from "react";
import { Delete, Edit } from "../icons";
import Next from "../../assets/next-icon.svg";
export default function DataTable({
  columns = [],
  rows = [],
  renderRow,
  onEditRow,
  onDeleteRow,
  page = 1,
  totalPages = 1,
  onNext,
  onPrev,
  isLoading,
  hidePagination = false,
}) {
  return (
    <div className="bg-white rounded-[10px] border border-[#D9D9D9] overflow-hidden">
      <div className="overflow-x-auto custom-scrollbar">
        <div className="min-w-[800px]">
          <div className="grid grid-cols-12 gap-4 px-4 sm:px-6 py-5 items-center">
            {columns.map((col) => (
              <div
                key={col.key}
                className={` text-[#878686] ${col.className || ""}`}
              >
                {col.label}
              </div>
            ))}
          </div>

          <div className="relative min-h-[150px]">
            {isLoading && (
              <div className="absolute inset-0 bg-white/50 backdrop-blur-[1px] flex items-center justify-center z-10">
                <svg className="animate-spin h-8 w-8 text-[#6D4E8A]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
            )}
            {rows.map((r, idx) =>
              renderRow ? (
                <React.Fragment key={idx}>{renderRow(r, idx)}</React.Fragment>
              ) : (
                <div key={idx} className="bg-[#EEEEEE40]">
                  <div className="grid grid-cols-12 gap-4 px-7 py-6 items-center border-b border-[#E5E5E5] ">
                    <div className="col-span-4 flex items-center gap-[14px] text-black">
                      <div className="w-[53px] h-[42px] flex justify-center items-center rounded bg-[#E4E3E5] capitalize">
                        <p>{r.name.charAt(0)}</p>
                      </div>
                      <div className="capitalize">{r.name}</div>
                    </div>

                    <div className="col-span-3">
                      <div className="inline-block bg-[#E5FFF6] text-[#2C765C] px-4  rounded-full text-xs leading-6">
                        {r.count} Items
                      </div>
                    </div>

                    <div className="col-span-3  text-black">{r.addedOn}</div>

                    <div className="col-span-2 flex justify-end gap-3">
                      <button
                        aria-label="edit"
                        className="cursor-pointer"
                        onClick={() => onEditRow?.(r, idx)}
                      >
                        <Edit />
                      </button>
                    </div>
                  </div>
                </div>
              ),
            )}
          </div>
        </div>
      </div>

      <div className="text-lg lg:text-xl leading-4 lg:leading-6 text-[#878686] px-4 sm:px-7 pt-7 sm:pt-9 pb-5 sm:pb-7 flex items-center justify-between">
        <div className="leading-[31px]">Showing {rows.length} results</div>
        {!hidePagination && (
          <div className="flex items-center gap-[9px]">
            <button onClick={onPrev} disabled={page <= 1 || isLoading} className=" bg-[#F0F0F0] px-3 py-2 rounded disabled:opacity-40">
              <img src={Next} alt="previous page" />
            </button>
            <div className="">Page {page}</div>
            <button onClick={onNext}   disabled={page >= totalPages || isLoading} className=" bg-[#F0F0F0] px-3 py-2  rounded disabled:opacity-40">
              <img src={Next} alt="previous page" className="rotate-180" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
